/*
interface DefaultTableProps {
  className: string;
}
*/

import DefaultCODField from "./DefaultCODField";

function DefaultTable({ className, codRef }) {
  return (
    <div className={className}>
      <div className="cdk-filter-table-container paper-panel-tight container-fluid">
        <div className="row font-weight-bold px-2 py-3 border-bottom">
          <div className="col-6 col-lg-3 col-xl-2">Column</div>
          <div className="col-6 col-lg-9 col-xl-10">Default Values if</div>
        </div>

        <div className="row px-2 py-3">
          <div className="col-6 col-lg-3 col-xl-2 mb-2 mb-lg-0">COD Type</div>
          <div className="col-12 col-lg-9 col-xl-10">
            <DefaultCODField ref={codRef} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DefaultTable;
